import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementById('page-top')) {
  pageTop()
}

function pageTop() {
  //  #####     ###    #####      ###
  //  ##  ##   ## ##   ##  ##    ## ##
  //  #####   ##   ##  #####    ##   ##
  //  ##      #######  ##  ##   #######
  //  ##      ##   ##  ##   ##  ##   ##

  /*
  GSAP 要素に対するパララックス効果
<div class="js-scrollPara" data-y="-150"></div>
*/

  scrollParallax()
  function scrollParallax() {
    if (!document.getElementsByClassName('js-scrollPara')[0]) {
      return
    }
    const gsapMediaQuery = gsap.matchMedia() // GSAP用メディアクエリ
    gsap.registerPlugin(ScrollTrigger) // スクロールトリガー起動

    gsapMediaQuery.add('(min-width:769px)', () => {
      gsap.utils.toArray('.js-scrollPara').forEach((wrap) => {
        const y = wrap.dataset.y || -100 // パララックス量取得
        const start = wrap.dataset.start || 'top top+=100' // パララックス開始位置取得

        gsap.to(wrap, {
          y: y,
          scrollTrigger: {
            trigger: wrap, // ターゲット要素
            start: start, // 開始位置
            end: 'bottom top', // 終了位置
            scrub: 0.5, // 補正倍率
            //markers: true, // デバッグ表示
          },
        })
      })
    })
  }

  //    ###    #####    #####   ##   ##  ######
  //   ## ##   ##  ##  ##   ##  ##   ##    ##
  //  ##   ##  #####   ##   ##  ##   ##    ##
  //  #######  ##  ##  ##   ##  ##   ##    ##
  //  ##   ##  #####    #####    #####     ##
  /*
  ホバー中、その要素とその連動要素全てに.hoverを付与

  <a href="" class="js-aboutToggle js-aboutToggle--hoge" data-hover-about="hoge"></a>
  <a href="" class="js-aboutToggle js-aboutToggle-target js-aboutToggle--hoge" data-about-toggle="hoge"></a>
  */
  const aboutToggleClass = 'js-aboutToggle'
  if (document.getElementsByClassName(aboutToggleClass)[0]) {
    aboutToggle()
  }
  function aboutToggle() {
    const hoverActiveClass = 'animated'
    const hoverItems = document.getElementsByClassName(aboutToggleClass)
    for (let index = 0; index < hoverItems.length; index++) {
      const hoverItem = hoverItems[index]
      const hoverGroup = document.getElementsByClassName(aboutToggleClass + '-target')
      const hoverTargets = document.getElementsByClassName(aboutToggleClass + '--' + hoverItem.dataset.aboutToggle)
      hoverItem.addEventListener(
        'mouseover',
        function () {
          for (const iterator of hoverGroup) {
            iterator.classList.remove(hoverActiveClass)
          }
          for (let index = 0; index < hoverTargets.length; index++) {
            hoverTargets[index].classList.add(hoverActiveClass)
          }
        },
        false
      )
    }
  }

  //  ##   ##  ##  ####    #####   #####
  //  ##   ##  ##  ##  ##  ##     ##   ##
  //  ##   ##  ##  ##  ##  #####  ##   ##
  //   ## ##   ##  ##  ##  ##     ##   ##
  //    ###    ##  ####    #####   #####

  if (document.getElementById('videoSlide')) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    const slideItem = document.getElementById('videoSlide')
    const sliderName = 'videoSlide'
    const videoSlideSwiper = new Swiper(slideItem, {
      // init: false, // 自動で初期化しない（videoSlideSwiper.init()で初期化）
      effect: 'slide', // slide,fade,cube,coverflow
      speed: 500, // アニメ速度
      loop: false, // ループ
      loopAdditionalSlides: 10, //ループ演出用のクローン数を増やして安定化させる

      // slidesPerView: 'auto', //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化
      preloadImages: false, // スライド内の画像を読み終えてから開始
      spaceBetween: 10, //スライド同士の間隔を空ける
      // centeredSlides: true, // 中央のスライドを基準にする
      // freeMode: true, //ドラッグ等でのスライド時、スライドが定位置以外で止まれるようにする
      // touchRatio: 0.3, // タッチスワイプ感度（0でタッチスワイプ無効）
      navigation: {
        nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
        prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
      },
      pagination: {
        // ページャーオプション
        el: '.swiper-pagination--' + sliderName, // ページャーを呼び出す要素
        type: 'progressbar', // bullets,fraction(現ページ/ページ数),progressbar,custom
        clickable: true, // クリックでジャンプ可能にする
      },
      breakpoints: {
        // 指定px以上でオプション切り替え
        769: {
          spaceBetween: 70, //スライド同士の間隔を空ける
        },
      },
    })
  }
}
